export default __webpack_public_path__ + "static/media/cl-4.d36f5d49.jpg";